import { X } from "lucide-react";
import { whatsappLink } from "../../data/site";

const OFFERS = [
  "Wedding Season Special",
  "Free trial sitting on every bridal booking",
  "Best Mehndi Artist in Pathankot",
  "Book early — dates fill fast",
];

const FestiveBanner = ({ onClose }) => {
  const loop = [...OFFERS, ...OFFERS];
  return (
    <div
      data-testid="festive-banner"
      className="fixed inset-x-0 top-0 z-[55] flex h-9 items-center overflow-hidden bg-maroon text-bone"
    >
      <a
        href={whatsappLink("Hi Arjun, I'd like to claim the wedding-season offer and book my bridal mehndi.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="festive-banner-cta"
        className="marquee-wrap block h-full flex-1"
        aria-label="Claim wedding season offer on WhatsApp"
      >
        <div
          className="marquee-track h-full items-center"
          style={{ animationDuration: "24s" }}
        >
          {loop.map((t, i) => (
            <span key={i} className="flex items-center whitespace-nowrap">
              <span className="px-6 text-xs uppercase tracking-[0.22em]">{t}</span>
              <span className="text-marigold">✦</span>
            </span>
          ))}
        </div>
      </a>
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClose();
        }}
        data-testid="festive-banner-close"
        aria-label="Dismiss offer"
        className="flex h-9 w-9 shrink-0 items-center justify-center bg-maroon text-bone/70 transition-colors hover:text-bone"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default FestiveBanner;
